export default "__VITE_ASSET__B$yZvKNL__"